var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mail-signature col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 no-gutters"},[_c('div',{staticClass:"author-name mb-5"},[_c('strong',[_vm._v(_vm._s(_vm.authorName))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.authorTitle)+" "+_vm._s(_vm.companyName))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }